export default function Chevron({ direction = 'down' }) {
  const rotation = (() => {
    switch (direction) {
      case 'up':
        return 'rotate(180deg)';
      case 'right':
        return 'rotate(90deg)';
      case 'down':
        return '';
      case 'left':
        return 'rotate(270deg)';
      default:
        return '';
    }
  })();

  return (
    <div
      style={{ transform: `rotate(0deg) ${rotation}`, marginLeft: '0.5rem' }}
    >
      <svg
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.00012 7.11609L6.11621 2L11.2323 7.11609"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
}
